module.exports = __webpack_public_path__ + "img/3.29a0e471.png";